export default __webpack_public_path__ + "static/enterprise-device-integration-52f839d55fbc626436b0c07465b58d35.jpeg";